
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic14 as ObiHydraulic14Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-14.js';
 
 
 

 
 export const ObiHydraulic14 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-14',
   elementClass: ObiHydraulic14Element,
   events: {
     
   }
  });
 
 